import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from '@apollo/client';
import client from './graphql/client';
import Slide from '@material-ui/core/Slide';
import { SnackbarProvider } from 'notistack';

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    TransitionComponent={Slide}
    >
      <App />
      </SnackbarProvider>

    </BrowserRouter>
    </ApolloProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
